import styled from "@emotion/styled";
import {Tab} from "@mui/material";
import {breakpoints} from "assets/theme";

export const Wrapper = styled.div`
	width: 100%;
	padding: 8px 20px 20px;
	background: #545456;
	position: relative;

	.MuiTabs-indicator {
		background: ${({theme}) => theme.colorPalette.secondary};
		z-index: 1;
	}

	.MuiTabs-root {
		min-height: 46px;
		position: relative;

		&:after {
			content: "";
			position: absolute;
			width: 100%;
			height: 2px;
			bottom: 0;
			background: #cccccc;
		}
	}

	@media (min-width: ${breakpoints.medium}) {
		border-radius: 4px 4px 0 0;
	}
`;

export const TabStyled = styled(Tab)`
	flex: 1;

	&.MuiTab-root {
		font-family: "Hind", sans-serif;
		min-height: 46px;
		text-transform: initial;
		font-weight: 500;
		font-size: 14px;
		color: #cccccc;
		max-width: none;

		&.Mui-selected {
			color: ${({theme}) => theme.colorPalette.secondary};
		}
	}
`;

export const TabPanelWrapper = styled.div`
	margin-top: 20px;
	max-height: 300px;
	overflow: auto;

	@media (max-height: 700px) {
		max-height: 250px;
	}
`;

export const OverviewWrapper = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;

	& > * {
		box-sizing: content-box;
		width: calc(33.3% - 10px); // 1/3 - border width - padding width

		&:nth-child(n + 4):nth-child(-n + 6) {
			background: #848484;
			border-top: none;
		}

		&:not(:nth-child(3n)) {
			border-right: none;
		}
	}
`;

export const OverviewItemWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	align-items: center;
	justify-content: center;
	padding: 18px 4px;
	color: ${({theme}) => theme.colorPalette.white};
	background: ${({theme}) => theme.colorPalette.black};
	border: 1px solid #cccccc;

	&&:last-of-type {
		border-right: 1px solid #cccccc;
	}
`;
